import React, { forwardRef, useImperativeHandle } from 'react';
import * as rsuite from 'rsuite';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';


const Drp_DocSetting = forwardRef((props, ref) => {

    const [List, setList] = React.useState([]);
    const [Id, setId] = React.useState("-1");
    const _Onchange = (value) => {
        props.onChange(value === null ? General.GuidEmpty() : value,
            value === null ? "" : List.find(x => x.Id == value).ACCC,
            value === null ? General.GuidEmpty() : List.find(x => x.Id == value).ACCCId,
            value === null ? -1 : List.find(x => x.Id == value).Sub_Acc_L1,
            value === null ? -1 : List.find(x => x.Id == value).Sub_Acc_L2,
            value === null ? -1 : List.find(x => x.Id == value).Sub_Acc_L3,
            value === null ? -1 : List.find(x => x.Id == value).Type,
            value === null ? "" : List.find(x => x.Id == value).Title)

        setId(value)
    }
    useImperativeHandle(ref, () => ({

        Bind(id, UsedIn = -1, Type = -1, IsAuto=-1) {
            var RequestOptions = {
                data: {
                    'UsedIn': UsedIn,
                    'Type': Type,
                    "IsAuto": IsAuto
                },
                url: General.ApiRoute() + "/DocSettings/SearchForDRP",
                method: "post",
                withCredentials: true,

                headers: {
                    'ApiKey': General.APIKey(),
                    'Content-Type': 'application/json'
                }
            }
            trackPromise(
                axios(RequestOptions)
                    .then(result => {
                        var tmp = []

                        for (var i = 0; i < result.data.length; i++) {
                            tmp.push({
                                Row: i + 1,
                                Id: result.data[i].id,
                                Title: result.data[i].comment,
                                ACCC: result.data[i].accc,
                                ACCCId: result.data[i].acccid,
                                Sub_Acc_L3: result.data[i].sub_Acc_L3,
                                Sub_Acc_L2: result.data[i].sub_Acc_L2,
                                Sub_Acc_L1: result.data[i].sub_Acc_L1,
                                Type: result.data[i].type,

                            })
                            if (result.data[i].id == id) {
                                props.onChange(result.data[i].id, result.data[i].accc, result.data[i].acccid, result.data[i].sub_Acc_L1, result.data[i].sub_Acc_L2, result.data[i].sub_Acc_L3, result.data[i].type, result.data[i].comment)
                            }
                        }
                        setList(tmp)
                        setId(id)

                    })
                    .catch((error) => {
                        console.dir(error)
                    })
            )
        },

    }))



    return (
        <rsuite.SelectPicker


            data={List}
            valueKey="Id"
            labelKey="Title"
            className='w-100p'
            placeholder="انتخاب کنید..."
            value={Id}
            onChange={(value) => _Onchange(value)}

        />

    )
});

export default Drp_DocSetting;